module.exports = __webpack_public_path__ + "img/logoQR.07b44014.png";